// Don't pre-select a size on product pages: shoppers were adding the first
// size (XS) to cart without choosing one. Clears the default size selection
// on load and blocks add-to-cart until a size is picked. Links that name a
// specific variant (?variant=) keep their selection. Also applies inside
// quick-add modals, which announce themselves with product-info:loaded.
(function () {
  if (window.requireSizeSelectionLoaded) return;
  window.requireSizeSelectionLoaded = true;

  function isSizeFieldset(fieldset) {
    var legend = fieldset && fieldset.querySelector('legend');
    return !!legend && /size/i.test(legend.textContent);
  }

  function findSizeFieldset(variantSelects) {
    return Array.from(variantSelects.querySelectorAll('fieldset.product-form__input')).find(isSizeFieldset);
  }

  function getForm(variantSelects) {
    return document.getElementById('product-form-' + variantSelects.dataset.section);
  }

  function getError(form) {
    var productForm = form.closest('product-form');
    var wrapper = productForm && productForm.querySelector('.product-form__error-message-wrapper');
    return { wrapper: wrapper, text: wrapper && wrapper.querySelector('.product-form__error-message') };
  }

  function init(variantSelects) {
    if (variantSelects.dataset.sizeRequiredInit) return;
    variantSelects.dataset.sizeRequiredInit = 'true';

    var fieldset = findSizeFieldset(variantSelects);
    if (!fieldset) return;

    var radios = fieldset.querySelectorAll('input[type="radio"]');
    if (radios.length < 2) return;

    var form = getForm(variantSelects);
    if (!form) return;

    radios.forEach(function (radio) {
      radio.checked = false;
    });
    var selectedLabel = fieldset.querySelector('[data-selected-value]');
    if (selectedLabel) selectedLabel.textContent = '';
    form.dataset.sizeRequired = 'true';
    form.dataset.selectSizeText = variantSelects.dataset.selectSizeText || 'Please select a size';
  }

  function initWithin(root) {
    if (new URLSearchParams(window.location.search).has('variant') && root === document) return;
    root.querySelectorAll('.product variant-selects').forEach(init);
  }

  // Dawn replaces <variant-selects> after each change, so listen at the document.
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || target.type !== 'radio') return;
    var variantSelects = target.closest('variant-selects');
    if (!variantSelects || !isSizeFieldset(target.closest('fieldset'))) return;
    var form = getForm(variantSelects);
    if (!form) return;
    delete form.dataset.sizeRequired;
    var error = getError(form);
    if (error.wrapper) error.wrapper.toggleAttribute('hidden', true);
    variantSelects.querySelectorAll('.product-form__input--needs-selection').forEach(function (el) {
      el.classList.remove('product-form__input--needs-selection');
    });
  });

  // Capture phase so this runs before Dawn's product-form submit handler.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.dataset.sizeRequired !== 'true') return;
      event.preventDefault();
      event.stopImmediatePropagation();

      // form.id would return the form's <input name="id">, so read the attribute.
      var sectionId = (form.getAttribute('id') || '').replace(/^product-form-/, '');
      var variantSelects = document.querySelector('variant-selects[data-section="' + sectionId + '"]');
      var fieldset = variantSelects && findSizeFieldset(variantSelects);
      var error = getError(form);
      if (error.wrapper && error.text) {
        error.text.textContent = form.dataset.selectSizeText;
        error.wrapper.toggleAttribute('hidden', false);
      }
      if (fieldset) {
        fieldset.classList.add('product-form__input--needs-selection');
        fieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var firstAvailable = fieldset.querySelector('input[type="radio"]:not(.disabled)');
        if (firstAvailable) firstAvailable.focus({ preventScroll: true });
      }
    },
    true
  );

  document.addEventListener('product-info:loaded', function (event) {
    if (event.target.closest('quick-add-modal')) initWithin(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initWithin(document);
    });
  } else {
    initWithin(document);
  }
})();
